import Joi from 'joi';
import { IntlFormatters } from 'react-intl';
import { URLRegEx } from '@marketplace/common';

export const documentationFormValidationSchema = ({
  formatMessage,
}: Pick<IntlFormatters, 'formatMessage'>) => {
  const documentationNameLabel = formatMessage({
    id: 'documentationForm_documentationName',
  });
  const documentationURLLabel = formatMessage({
    id: 'documentationForm_documentationURL',
  });
  const documentationLicenseURLLabel = formatMessage({
    id: 'documentationForm_licenseURL',
  });
  const supportDescriptionLabel = formatMessage({
    id: 'documentationForm_licenseURL',
  });

  return Joi.object({
    name: Joi.string()
      .trim()
      // eslint-disable-next-line
      .max(100)
      .min(3)
      .messages({
        'string.pattern.base': formatMessage(
          { id: 'generalForm_validation_allowed' },
          { field: documentationNameLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: documentationNameLabel, min: 3, max: 100 }
        ),
        'string.min': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: documentationNameLabel, min: 3, max: 100 }
        ),
      })
      .allow(''),
    url: Joi.string()
      .trim()
      .pattern(URLRegEx)
      .allow('')
      .max(2000)
      .messages({
        'string.pattern.base': formatMessage(
          { id: 'generalForm_validation_uri' },
          { field: documentationURLLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: documentationURLLabel, min: 1, max: 2000 }
        ),
      }),
    support_description: Joi.string()
      .max(2000)
      .min(3)
      .messages({
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: supportDescriptionLabel, min: 3, max: 1000 }
        ),
        'string.min': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: supportDescriptionLabel, min: 3, max: 1000 }
        ),
      })
      .allow(''),
    licence_url: Joi.string()
      .trim()
      .pattern(URLRegEx)
      .allow('')
      .messages({
        'string.pattern.base': formatMessage(
          { id: 'generalForm_validation_uri' },
          { field: documentationLicenseURLLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: documentationLicenseURLLabel, min: 1, max: 2000 }
        ),
      }),
  });
};
